module.exports = __webpack_public_path__ + "static/media/img-d-archer.d0a63c43.png";